import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/StoreManagement'
    },

    // 登录
    {
        path: '/Login',
        name: 'Login',
        component: () => import('../views/login.vue')
    },
    // 门店管理
    {
        path: '/StoreManagement',
        name: 'StoreManagement',
        component: () => import('../views/StoreManagement.vue')
    },
    // 轮播图管理
    {
        path: '/CarouselManagement',
        name: 'CarouselManagement',
        component: () => import('../views/carouselManagement.vue')
    },
    // 通知管理
    {
        path: '/NotificationManagement',
        name: 'NotificationManagement',
        component: () => import('../views/notificationManagement.vue')
    },
    // 教室管理
    {
        path: '/ClassroomManagement',
        name: 'ClassroomManagement',
        component: () => import('../views/classroomManagement.vue')
    },
    // 教室订单管理
    {
        path: '/OrderManagement/ClassroomOrderManagement',
        name: 'ClassroomOrderManagement',
        component: () => import('../views/classroomOrderManagement.vue')
    },
    // 课程订单管理
    {
        path: '/OrderManagement/CourseOrderManagement',
        name: 'CourseOrderManagement',
        component: () => import('../views/courseOrderManagement.vue')
    },
    // 教室次卡管理
    {
        path: '/CardManagement/ClassroomCardsManagement',
        name: 'ClassroomCardsManagement',
        component: () => import('../views/classroomCardsManagement.vue')
    },
    // 课程卡管理
    {
        path: '/CardManagement/CourseCardsManagement',
        name: 'CourseCardsManagement',
        component: () => import('../views/courseCardsManagement.vue')
    },
    // 课程管理
    {
        path: '/CourseManagement',
        name: 'CourseManagement',
        component: () => import('../views/courseManagement.vue')
    },
    // 用户管理
    {
        path: '/UserManagement',
        name: 'UserManagement',
        component: () => import('../views/userManagement.vue')
    },
]

const router = new VueRouter({
    routes
})

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};

export default router
